// extracted by mini-css-extract-plugin
export default {"container":"container--39PZY","chat":"chat--M5_u0","message":"message--2GXUA","loader":"loader--1YjwU"};